function haliProductCard({ shopify, formatted }) {
  console.log('shopify, formatted', { shopify, formatted });
  const variantInfo = formatted.variantInfo ? formatted.variantInfo : '';
  const color = variantInfo.split('/')[0];
  const size = variantInfo.split('/')[1];

  return /*html*/ `
<li data-wishlist-card class="product-card {{ product_card }}">
    <a >
        <div class="product-card-image">
        <a href="${formatted.du}">
            <div class="wl-aspect-outer">
                <div class="wl-aspect-inner"> 
                    <img
                        src="${shopify.image.src}"
                        alt="${shopify.title}"
                        width="100%"
                        height="100%"
                        style="object-fit: cover;"
                        class="wishlist-image"
                    >
                </div>
            </div>
        </a>
        </div>
        <div class="product-card-title-row">
            <p class="type-product-title product-card-title text-dark">${shopify.title}</p>
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="${
              formatted.epi
            }" data-product-id="${formatted.empi}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">    <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"

            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8.99775 16.1494L8.07594 15.3422C6.48863 13.9285 5.18012 12.7112 4.14589 11.6858C3.11167 10.6605 2.28428 9.74418 1.66825 8.93698C1.05221 8.12978 0.620535 7.39676 0.373221 6.74227C0.125906 6.08778 0 5.42457 0 4.757C0 3.44366 0.454159 2.35285 1.36248 1.47148C2.2708 0.594464 3.39045 0.153777 4.72595 0.153777C5.58031 0.153777 6.37172 0.350123 7.10017 0.742815C7.82863 1.13551 8.46266 1.70273 9.00225 2.44448C9.63178 1.65909 10.2973 1.07878 11.0032 0.707909C11.7092 0.337033 12.4647 0.149414 13.274 0.149414C14.6095 0.149414 15.7292 0.590101 16.6375 1.46711C17.5458 2.34412 18 3.4393 18 4.75263C18 5.42021 17.8741 6.08342 17.6268 6.73791C17.3795 7.39239 16.9478 8.12542 16.3317 8.93262C15.7157 9.73981 14.8928 10.6561 13.8541 11.6815C12.8199 12.7068 11.5069 13.9242 9.92405 15.3379L9.00225 16.1451L8.99775 16.1494ZM8.99775 14.4259C10.5131 13.0733 11.7632 11.9127 12.7434 10.9484C13.7237 9.97979 14.5016 9.13332 15.0772 8.40466C15.6528 7.676 16.0575 7.03024 16.2913 6.45866C16.5251 5.89144 16.642 5.32422 16.642 4.76136C16.642 3.80145 16.3273 3.00734 15.6977 2.39212C15.0682 1.7769 14.2588 1.46275 13.274 1.46275C12.5006 1.46275 11.7857 1.694 11.1292 2.15214C10.4726 2.61028 9.94204 3.25604 9.53734 4.08506H8.43567C8.04446 3.26913 7.52286 2.6321 6.86635 2.16523C6.20984 1.69836 5.49488 1.46711 4.72146 1.46711C3.7367 1.46711 2.9273 1.7769 2.29778 2.39648C1.66825 3.01606 1.35348 3.80581 1.35348 4.77008C1.35348 5.33294 1.47039 5.90016 1.70422 6.47611C1.93804 7.05206 2.34274 7.70654 2.91831 8.43957C3.49388 9.17259 4.28079 10.0234 5.27005 10.9833C6.25931 11.9432 7.50487 13.0908 9.00225 14.4303L8.99775 14.4259Z" />
        </svg></button>
        </div>

        <div class="product-card-accordions">

            <div class="product-card-accordion">
                <select data-color>
                    <option  disabled="disabled">Colour</option>
                    ${shopify.options
                      .find((x) => x.name == 'Color')
                      .values.map(
                        (x) =>
                          `<option ${
                            x == color ? 'selected="true"' : ''
                          } class="type-product-title product-card-title text-dark">${x}</option>`
                      )
                      .join('')}
                </select>
            </div>

            <div class="product-card-accordion">
                <select data-size>
                    <option  disabled="disabled">Size</option>
                    ${shopify.options
                      .find((x) => x.name == 'Size')
                      .values.map(
                        (x) =>
                          `<option ${
                            x == size ? 'selected="true"' : ''
                          } class="type-product-title product-card-title text-dark">${x}</option>`
                      )
                      .join('')}
                </select>
                <select data-variant hidden>
                    ${shopify.variants.map((x) => /*html*/ `<option value=${x.id}>${x.title}</option>`).join('')}
                </select>
            </div>
            
        </div>

        <p class="type-product-title product-card-price text-grey">
            From $${parseInt(formatted.pr)}
        </p>
        <div style="padding-top:17px; display:flex; gap:20px; flex-direction:row;">

            <form method="post" action="/cart/add">
                <input data-atc type="hidden" name="id" value="false" />
                <input min="1" type="hidden" id="quantity" name="quantity" value="1"/>
                <input type="submit" value="Add to cart" class="button button-filled-black" />
            </form>

            <a href="${formatted.du}" class="button button-black">View More</a>
        </div>
    </a>
</li>
`;
}

function getVariantInfo(variants) {
  try {
    let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == 'Default Title') {
        variantinfo = '';
      }
    } else {
      variantinfo = '';
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute('data-variant-id');
  var empi = +e.currentTarget.getAttribute('data-product-id');

  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function renderWishlist(products) {
  const formattedWishlistedProducts = products.map((p) => p.formatted);

  const cards = products.map((x) => haliProductCard(x)).join('');

  const target = document.querySelector('#wishlist-items-container');

  if (cards) {
    target.innerHTML = cards;
  }
}

function renderEmptyPage() {
  const target = document.querySelector('#wishlist-items-container');

  const html = `
	        <div class="cart-empty" style="grid-column: 1/-1;">
            <div class="empty-inner">
                <p class="type-body-medium">Your wishlist is empty</p>
                <a href="/" class="button button-black">Back to home</a>
            </div>
        </div>`;

  target.innerHTML = html;
}

function swymRenderWishlist(swat) {
  swat.fetch(async function (products) {
    const out = [];
    for (const p of products) {
      const formattedPrice = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      const isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
      const variantInfo = p.vi ? getVariantInfo(p.vi) : '';

      const url = new URL(p.du).pathname + '.json';

      const shopify = await fetch(url);

      const data = await shopify.json();

      out.push({
        shopify: data.product,
        formatted: {
          ...formattedPrice,
          isInCart,
          variantInfo,
        },
      });
    }
    if (out.length > 0) {
      renderWishlist(out);
      attachClickListeners();
    } else {
      renderEmptyPage();
    }
  });
}

function resolveVariant(size, color, card) {
  const atc_button = card.querySelector('[data-atc]');
  const variant_select = card.querySelector('[data-variant]');
  const value = Array.from(variant_select.querySelectorAll('option')).find((x) => x.innerText.includes(size));
  if (value) {
    const newValue = value.value;
    variant_select.value = newValue;
    atc_button.value = newValue;
  }
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll('#swym-custom-add-toCartBtn');
  var removeBtns = document.querySelectorAll('#swym-remove-productBtn');
  const cards = document.querySelectorAll('[data-wishlist-card]');

  cards.forEach((card) => {
    const color = card.querySelector('[data-color]');
    const size = card.querySelector('[data-size]');

    [size, color].forEach((el) => {
      el.addEventListener('change', (e) => {
        resolveVariant(size.value, color.value, card);
      });
      resolveVariant(size.value, color.value, card);
    });
  });

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', addItemToCart);
  }

  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  // console.log('Events attached!');
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
